<template>
    <div class="multi-select-bar"
         :class="[hideInput && 'hide-input', hideBorder && 'no-border']"
         :style="{width: `${width}px`}"
    >
        <div
            :class="{
                'not-allowed': disabled,
                'isActive': visible,
                'select-result': true,
            }"
            @click="handleOpenModal"
            :style="{height: calHeight}"
            :title="strResultNames"
        >
            <div class="c-999 f12" v-if="resultList.length === 0">{{ placeholder }}</div>
            <div v-else>
                <span class="has-chosen f12">
                    已{{ excludeSelected ? '排除' : '选' }}{{ resultList.length}}项
                </span>
            </div>
            <span class="to-choose flex-center">
                <span :class="clearable && resultList.length > 0 && 'choose-text'" class="f12">选择</span>
                <i class="el-icon-error f12 c-999 can-change-error"
                   v-if="clearable && resultList.length > 0"  @click.stop="handleDelete"></i>
            </span>
        </div>

        <DapMultiSelectDialog
            :visible.sync="visible"
            v-bind="$attrs"
            :resultList="resultList" :propsMapper="propsMapper"
            :placeholder="placeholderSearch"
            :excludeSelected="excludeSelected"
            :showExcludeSelected="showExcludeSelected"
            :modalHandTips="modalHandTips"
            :maxLenth="maxLenth"
            @change="handleChangeSelect">
            <slot slot="search-prefix" name="search-prefix" />
            <slot slot="search-prepend" name="search-prepend" />
            <slot slot="select-all-tip" name="select-all-tip" />
            <slot slot="left-title" name="left-title" />
            <template v-slot:result="{item}">
                <slot name="result" :item="item"></slot>
            </template>
            <template v-slot:label="{item}">
                <slot name="label" :item="item"></slot>
            </template>
        </DapMultiSelectDialog>

    </div>
</template>

<script>
    import DapMultiSelectDialog from './MultiSelectDialog'
    export default {
        name: 'DapMultiSelectBar',

        components: {
            DapMultiSelectDialog,
        },

        props: {
            resultList: {
                type: Array,
                default: () => []
            },
            // 对应的数据源的属性
            propsMapper: {
                type: Object,
                default: () => ({ value: 'value', label: 'label' })
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            hideInput: {
                type: Boolean,
                default: false,
            },
            hideBorder: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: true,
            },
            placeholder: {
                type: String,
                default: '请选择',
            },
            placeholderSearch: {
                type: String,
                default: '请输入搜索的内容',
            },
            width: {
                type: [Number, String],
                default: 200
            },
            size: {
                type: String,
                default: 'mini',
            },
            excludeSelected: {
                type: Boolean,
                default: false,
            },
            showExcludeSelected: {
                type: Boolean,
                default: false,
            },
            modalHandTips: {
                type: String,
                default: '',
            },
            maxLenth: {
                type: Number,
                default: 0
            },
        },
        computed: {
            strResultNames () {
                return this.resultList.map(i => i[this.propsMapper.label]).join(',');
            },
            calHeight () {
                return {
                    mini: '26px',
                    small: '30px',
                }[this.size];
            }
        },
        data () {
            return {
                visible: false,
            };
        },
        methods: {
            handleChangeSelect (res, exclude) {
                this.$emit('change', res, exclude);
            },
            handleOpenModal () {
                this.visible = !this.disabled;
            },

            handleDelete () {
                if (this.disabled) return;
                if (!this.hideInput) {
                    this.$emit('change', []);
                    this.$emit('delete');
                } else {
                    this.handleOpenModal();
                }
            }
        },
    };
</script>

<style lang="scss">
    .multi-select-bar {
        border: 1px solid #DCDFE6;
        transition: border-color 0.2s;
        border-radius: 4px;
        user-select: none;
        padding: 0 8px 0 15px;
        box-sizing: border-box;


        .can-change-error {
            display: none;
        }

        &:hover {
            border-color: #C0C4CC;
            .can-change-error {
                display: inline-block;
            }
            .choose-text {
                display: none;
            }
        }

        &.hide-input {
            border-color: transparent;
            .select-result > div, .select-result > span {
                display: none;
            }
        }

        &.no-border {
            border-color: transparent;
        }

        &.isActive {
            border-color: #4285F4;
        }

        .select-result {
            position: relative;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            cursor: pointer;
            padding: 0;
            .has-chosen {
                color: #606266;
            }
            .to-choose {
                color: #4284F4;
            }

            &.not-allowed {
                cursor: not-allowed;
                color: #999;
            }
        }

        /*.multi-select-modal {*/
        /*    width: 710px;*/
        /*    .dialog-content {*/
        /*        padding: 0 20px 20px 20px;*/
        /*    }*/

        /*    .dialog-footer {*/
        /*        text-align: right;*/
        /*    }*/
        /*}*/
    }
</style>
